import type { IconDefinition } from '../../types'

export default {
  details: [20, 20, [], '', 'M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16Z'],
  name: 'uiRadioSelected',
  oldName: 'cuiRadioSelected',
	pathProps: { fillRule: 'evenodd', clipRule: 'evenodd' }
} as IconDefinition
